import { CloseIcon } from '@/components/ui/Icons';
import { MessengerChatHeader } from '@/components/Messenger/shared/chrome/MessengerChatHeader';
import './ChatShellEmptyPane.css';

interface ChatShellEmptyPaneProps {
  onClose: () => void;
}

export function ChatShellEmptyPane({ onClose }: ChatShellEmptyPaneProps) {
  return (
    <div className="chatShellEmptyPane" role="region" aria-label="Мессенджер">
      <MessengerChatHeader
        headerClassName="chatAssistant__header"
        title="Мессенджер"
        right={
          <button
            type="button"
            className="chatAssistant__close"
            onClick={onClose}
            aria-label="Закрыть мессенджер"
          >
            <CloseIcon size={20} aria-hidden />
          </button>
        }
      />
    </div>
  );
}
